import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-translate';
import { Icon, Label, Segment, Step } from 'semantic-ui-react';
import { getFirstPage } from '../../constants/envList';
import PDFService, { PageType } from '../../services/PDFService';
import productInfos from '../Protected/projet/productInfos';
import './Etape.css';

const onClick = (history, commonState, pageIdx, toPage, env) => {
  const first = getFirstPage(env);
  if (toPage === `${env}/${first}`) {
    PDFService.clearCanvas();
  }
  let pageType;
  switch (pageIdx) {
    case 1:
      pageType = PageType.LANDING;
      break;
    case 2:
      pageType = PageType.COMPARE;
      break;
    case 3:
      pageType = PageType.STANDARD;
      break;
    case 4:
      pageType = PageType.RT_MAX;
      break;
    case 5:
      pageType = PageType.RT_PLUS;
      break;
    default:
      pageType = '';
  }
  PDFService.screenPage(pageType).then(() => {
    history.push({
      pathname: toPage,
      state: commonState,
    });
  });
};

const Etape = ({ currentPage, commonState, history, t, env }) => {
  const { formula } = productInfos[env];

  const steps = [
    (
      <Step
        key="project"
        id="etape"
        className={cx({ completedEtape: currentPage === 1 })}
        onClick={() => onClick(history, commonState, currentPage, `/${env}/projet`, env)}
      >
        <hr
          id="hrEtape"
          className={currentPage > 1 ? 'completed first' : 'first'}
        />
        <Segment
          id="triangle"
          className={currentPage === 1 ? 'activated' : 'disabled'}
        />
        <Icon name="projet" />
        <Step.Content>
          <Label
            id="etapeSphere1"
            circular
            size="big"
            className={currentPage > 1 ? 'completedSphere' : ''}
          >
            1
          </Label>
          <Step.Title
            id="titreNavBar"
            className={currentPage > 1 ? 'completedTitle' : ''}
          >
            {t('firststep')}
          </Step.Title>
        </Step.Content>
      </Step>
    ),
    (
      <Step
        id="etape"
        key="compare"
        className={currentPage === 2 ? 'completedEtape' : ''}
        onClick={() => onClick(history, commonState, currentPage, `/${env}/compare`)}
        disabled={!!(commonState.isoValue === null || commonState.isoValue === 0)}
      >
        <hr
          id="hrEtape"
          className={cx({ completed: currentPage > 2 })}
        />
        <Segment
          id="triangle"
          className={currentPage === 2 ? 'activated' : 'disabled'}
        />
        <Icon name="solution standard" />
        <Step.Content>
          <Label
            id="etapeSphere2"
            circular
            size="big"
            className={currentPage > 2 ? 'completedSphere' : ''}
          >
            2
          </Label>
          <Step.Title
            id="titreNavBar"
            className={currentPage > 2 ? 'completedTitle' : ''}
          >
            {t('secondstep')}
          </Step.Title>
        </Step.Content>
      </Step>
    ),
  ];

  const formulaValues = Object.values(formula);

  formulaValues.forEach((fomulaData, index) => {
    const currentIndex = index + 3; // index start at 0 + already 2 step
    const { step } = fomulaData;
    steps.push((
      <Step
        id="etape"
        key={step}
        className={currentPage === currentIndex ? 'completedEtape' : ''}
        onClick={() => onClick(history, commonState, currentPage, `/${env}/${step}`)}
        disabled={!!(commonState.isoValue === null || commonState.isoValue === 0)}
      >
        <hr
          id="hrEtape"
          className={cx({
            completed: currentPage > currentIndex && index < formulaValues.length - 1,
            last: index === formulaValues.length - 1,
          })}
        />
        <Segment
          id="triangle"
          className={currentPage === currentIndex ? 'activated' : 'disabled'}
        />
        <Icon name={`solution ${step}`} />
        <Step.Content>
          <Label
            id={`etapeSphere${currentIndex}`}
            circular
            size="big"
            className={currentPage > currentIndex ? 'completedSphere' : ''}
          >
            {currentIndex}
          </Label>
          <Step.Title
            id="titreNavBar"
            className={currentPage > currentIndex ? 'completedTitle' : ''}
          >
            {t(fomulaData.stepTitle)}
          </Step.Title>
        </Step.Content>
      </Step>
    ));
  });

  return (
    <Segment id="bandeau">
      <Segment id="etapeGroup">
        <Step.Group id="groupBloc">
          {steps}
        </Step.Group>
      </Segment>
    </Segment>
  );
};

Etape.propTypes = {
  currentPage: PropTypes.number,
  commonState: PropTypes.any,
  history: PropTypes.object,
  t: PropTypes.func.isRequired,
  env: PropTypes.string.isRequired,
};

export default translate('Etape')(Etape);



// WEBPACK FOOTER //
// ./src/components/shared/Etape.js